import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=d1a649bc&scoped=true"
import script from "./edit.vue?vue&type=script&lang=ts&setup=true"
export * from "./edit.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1a649bc",
  null
  
)

export default component.exports